import { Icon } from '../../../shared/components/Icon';
import type { PublicSettings } from '../types';
import { Reveal } from './Reveal';

export function Contact({ settings }: { readonly settings: PublicSettings }) {
  return (
    <Reveal>
      <h2 className="m-0 mb-3.5 text-[clamp(26px,4vw,34px)] font-bold leading-tight tracking-[-0.03em] text-text">
        Let&rsquo;s build something <em className="not-italic text-accent">solid</em>.
      </h2>

      <p className="mt-0">
        If you have a system that needs designing, rescuing or scaling, tell me what
        you&rsquo;re working on. I reply to everything.
      </p>

      <div className="mt-6 flex flex-wrap gap-2.5">
        <a
          href={`mailto:${settings.email}`}
          className="inline-flex items-center gap-[9px] rounded-full border border-accent bg-accent px-[18px] py-[11px] text-[13px] font-semibold text-bg transition-[background-color,transform] duration-250 hover:-translate-y-0.5 hover:bg-accent-hover"
        >
          <Icon name="mail" size={14} />
          {settings.email}
        </a>

        <a
          href={settings.linkedInUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-[9px] rounded-full border border-line px-[18px] py-[11px] text-[13px] font-medium text-muted transition-[color,border-color,transform,background-color] duration-250 hover:-translate-y-0.5 hover:border-accent-line hover:bg-accent-soft hover:text-accent"
        >
          <Icon name="linkedin" size={14} />
          LinkedIn
        </a>

        <a
          href={settings.gitHubUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-[9px] rounded-full border border-line px-[18px] py-[11px] text-[13px] font-medium text-muted transition-[color,border-color,transform,background-color] duration-250 hover:-translate-y-0.5 hover:border-accent-line hover:bg-accent-soft hover:text-accent"
        >
          <Icon name="github" size={14} />
          GitHub
        </a>
      </div>
    </Reveal>
  );
}
